import axios        from "axios";
import {url_path}   from "./paths";


export default {
    state: {
        pointInfo: { }
    },
    mutations: {
        setPointInfo (state, payload) {
            state.pointInfo = payload;
        }
    },
    actions: {

        async finishUploading ({commit}, array){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_documents_finish, {data: array});
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },

        async deleteDocument ({commit}, id){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_documents_delete + id);
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },

        async updateDocument ({commit}, {id, latitude, longitude, heading, label}){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_documents_edit + id, {latitude: latitude, longitude: longitude, heading: heading, label: label});
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },

        setPointInfo ({commit}, payload) {
            commit('setPointInfo', payload);
        }

    },
    getters: {
        uploadUrl (){
            return url_path.url_documents_add;
        },
        leafletToken (){
            return url_path.leaflet_token;
        },
        sharedUrl (){
            return url_path.shared_url;
        },
        pointInfo (state){
            return state.pointInfo;
        }
    }
}
